export default "__VITE_ASSET__da1393cd__"